"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Search = function (_a) {
    var value = _a.value, onChange = _a.onChange, style = _a.style, themeMode = _a.themeMode, currentTheme = _a.currentTheme, _b = _a.placeholder, placeholder = _b === void 0 ? "Search" : _b, _c = _a.fontSize, fontSize = _c === void 0 ? "1rem" : _c;
    // Default styles for the Search component
    var defaultStyles = {
        background: currentTheme.homePage.searchBackground || "transparent",
        flex: 1,
        marginRight: "1rem",
        outline: "none",
        border: "none",
        color: themeMode === "dark" ? "#ffffff" : "#0b0731",
        borderRadius: "0.7rem",
        display: "flex",
        alignItems: "center",
        padding: "0.7rem 1.4rem",
    };
    return (react_1.default.createElement("div", { className: "search-container", style: __assign(__assign({}, defaultStyles), style) },
        react_1.default.createElement("img", { className: "search-icon", height: "18px", width: "18px", src: themeMode === "dark"
                ? "/icons/search.svg"
                : "/icons/search-black.svg", alt: "search" }),
        react_1.default.createElement("input", { type: "text", className: "search-input", placeholder: placeholder, value: value, onChange: function (e) { return onChange(e.target.value); }, style: {
                color: themeMode === "dark" ? "#ffffff" : "#0b0731",
                background: "transparent",
                border: "none",
                outline: "none",
                boxShadow: "none",
                flex: 1,
                fontSize: fontSize,
                padding: 0,
                marginLeft: "0.5rem",
            } })));
};
exports.default = Search;
